import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200/60 border-t border-background-300/50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-semibold text-foreground-900 tracking-tight">
                Basetao<span className="text-primary-500">Sheet</span>
              </span>
            </Link>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4">
              The ultimate Basetao Spreadsheet resource hub. Discover product guides, shipping calculators, warehouse tips, and expert reviews.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                Home
              </Link>
              <Link to="/article/basetao-spreadsheet-guide" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                Complete Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                Basetao Spreadsheet
              </a>
            </div>
          </div>

          {/* Popular Categories */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Popular Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Resources</h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/basetao-spreadsheet-guide" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                Basetao Spreadsheet Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                Visit Main Store
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                Buy It Now
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Spreadsheet Hub. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            This is an independent resource site. Basetao is a trademark of its respective owner.
          </p>
        </div>
      </div>
    </footer>
  );
}